import styled from 'styled-components';

import { fontFamilySize, colors, px } from '../../../../../../contrib/ui';

export const NewSeasonStyled = styled.div`
  .paper {
    &.hidden {
      position: absolute;
      transition: transform 400ms cubic-bezier(0.645, 0.045, 0.355, 1),
        opacity 400ms cubic-bezier(0.785, 0.135, 0.15, 0.86),
        height 700ms 200ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
      height: 0;
      opacity: 0;
      transform: scale(0);
    }

    .date-separator {
      line-height: 5;
      font-size: calc(var(--apx) * 14);
      color: var(--grey87);
    }

    .label {
      font-size: calc(var(--apx) * 14);
      color: var(--grey87);
    }
    .form-errors {
      font-size: calc(var(--apx) * 14);
      color: red;
    }
    .datepicker {
      width: 100%;
    }
    .save-buttons {
      margin-top: calc(var(--apx) * 20);
    }

    .use-indexes {
      .subsection-label {
        margin-top: ${px(5)};
        margin-bottom: 0;
        ${fontFamilySize('Medium', 16)};
        color: ${colors.grey9b};
      }

      .subsection-fields {
        display: flex;
        flex-direction: row;
        align-items: center;

        .input-form-control {
          .material-input {
            margin-top: 0;
          }
        }

        .input-filler {
          ${fontFamilySize('Bold', 14)};
          color: ${colors.grey9b};
        }
      }
    }
  }
`;
